import { z } from 'zod'
import { timestampSchema, uuidSchema } from './common.ts'

export const CRM_DOMAIN_EVENT_TYPES = [
  'deal.created',
  'deal.status_changed',
  'deal.manager_changed',
  'deal.seller_changed',
  'deal.details_changed',
  'deal.comment_added',
  'deal.pricing_changed',
  'deal.line_items_changed',
  'deal.task_created',
  'deal.task_updated',
  'deal.task_completed',
  'deal.task_cancelled',
  'client.manager_changed',
] as const
export const INVOICE_DOMAIN_EVENT_TYPES = [
  'invoice.created',
  'invoice.details_changed',
  'invoice.issued',
  'invoice.payment_recorded',
  'invoice.payment_reversed',
  'invoice.approved',
  'invoice.rejected',
  'invoice.attachment_added',
  'invoice.attachment_removed',
] as const
export const PAYMENT_REQUEST_DOMAIN_EVENT_TYPES = [
  'payment_request.details_changed',
  'payment_request.approved',
  'payment_request.attachment_added',
  'payment_request.attachment_removed',
] as const
export const PROPOSAL_DOMAIN_EVENT_TYPES = [
  'proposal.created',
  'proposal.sent',
  'proposal.accepted',
  'proposal.rejected',
  'proposal.superseded',
] as const
export const WAREHOUSE_DOMAIN_EVENT_TYPES = [
  'stock.received',
  'stock.transferred',
  'stock.reserved',
  'stock.shortage',
] as const
export const WAYBILL_DOMAIN_EVENT_TYPES = ['waybill.reviewed', 'waybill.confirmed'] as const
export const PRODUCTION_DOMAIN_EVENT_TYPES = ['bom.released', 'production.output_recorded'] as const
export const LOGISTICS_DOMAIN_EVENT_TYPES = ['shipment.changed'] as const

export const crmDomainEventTypeSchema = z.enum(CRM_DOMAIN_EVENT_TYPES)
export type CrmDomainEventType = z.infer<typeof crmDomainEventTypeSchema>
export const domainEventTypeSchema = z.enum([
  ...CRM_DOMAIN_EVENT_TYPES,
  ...INVOICE_DOMAIN_EVENT_TYPES,
  ...PAYMENT_REQUEST_DOMAIN_EVENT_TYPES,
  ...PROPOSAL_DOMAIN_EVENT_TYPES,
  ...WAREHOUSE_DOMAIN_EVENT_TYPES,
  ...WAYBILL_DOMAIN_EVENT_TYPES,
  ...PRODUCTION_DOMAIN_EVENT_TYPES,
  ...LOGISTICS_DOMAIN_EVENT_TYPES,
])
export type DomainEventType = z.infer<typeof domainEventTypeSchema>

export const crmDomainEventSchema = z.object({
  id: uuidSchema,
  type: domainEventTypeSchema,
  version: z.literal(1),
  aggregateType: z.enum([
    'deal',
    'client',
    'invoice',
    'payment_request',
    'proposal',
    'stock',
    'bom',
    'order',
    'waybill',
    'shipment',
  ]),
  aggregateId: uuidSchema,
  // Staff ids are uuids, but the column is text and older rows carry other actor labels; one
  // unparseable row would otherwise stall delivery of everything queued behind it.
  actorId: z.string().min(1).nullable(),
  correlationKey: z.string().min(1),
  payload: z.record(z.string(), z.unknown()),
  occurredAt: timestampSchema,
})

export type CrmDomainEvent = z.infer<typeof crmDomainEventSchema>
